import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

function ConfirmModal({ modal, setModal, confirm }) {
	const { t } = useTranslation()

	return (
		<>
			<Modal show={modal} centered onHide={() => setModal(false)}>
				<i className="uil-times" onClick={() => setModal(false)}></i>
				<div className="modal-title mb-12">
					{t('confirm_action_question')}
				</div>
				<div className="modal-subtitle mb-32">
					{t('are_you_sure_to_finish')}
				</div>

				<div className="modal-footer">
					<button className="white" onClick={() => setModal(false)}>
						{t('cancel')}
					</button>
					<button className="dark" onClick={confirm}>
						{t('confirm')}
					</button>
				</div>
			</Modal>
		</>
	)
}

export default ConfirmModal
